import * as React from "react";
import { cn } from "@/lib/utils";

export interface EmptyStateProps {
  /**
   * The message to display
   */
  message: string;
  /**
   * Optional height for the container
   * @default "400px"
   */
  height?: string;
  /**
   * Additional CSS class names
   */
  className?: string;
}

/**
 * A component for displaying empty state messages in a centered layout.
 * This is the shadcn equivalent of the MUI-based SelectSomething component.
 */
export const EmptyState = ({
  message,
  height = "400px",
  className,
}: EmptyStateProps): React.JSX.Element => {
  return (
    <div
      className={cn("flex items-center justify-center", className)}
      style={{ height }}
    >
      <h1 className="text-center text-muted-foreground text-2xl font-bold">
        {message}
      </h1>
    </div>
  );
};
